
import React, { useState } from "react";
import { Link } from "react-router-dom";

export default function InstallationTab() {

  const [activeTab, setActiveTab] = useState("Power Issues");

  const tabs = [
    {
      id: "Power Issues",
      title: "Wrong Wiring Costs More",
      description:
        "Your facility's existing electrical setup was built for a different load. When an industrial washer draws full power through undersized circuits, breakers trip, voltage drops, and machines underperform from day one. We calculate exact demand per unit, test your panel against it, and fix every mismatch before a single machine is connected.",
      img: "/assets/images/power-img1.webp",
    },
    {
      id: "Water Supply",
      title: " Pressure Drops Kill Performance",
      description:
        "Inlet pressure that looked fine on paper often tells a different story at the actual connection point. Slow fill rates, incomplete rinse cycles, and premature valve wear all trace back to inadequate water supply. We test pressure and flow where it matters, at the machine connection, and resolve any shortfall before installation proceeds.",
      img: "/assets/images/power-img2.webp",
    },
    {
      id: "Drainage Problems",
      title: "Drains Fail Under Load",
      description:
        "Industrial machines discharge large volumes in short bursts. Drain lines that handled a previous setup often cannot keep up with a new one. We calculate peak discharge rate for every machine being installed, inspect your existing drain infrastructure against it, and identify every upgrade needed before water starts flowing.",
      img: "/assets/images/power-img3.webp",
    },
    // {
    //   id: "Floor Stability",
    //   title: "Floors Fail Quietly",
    //   description:
    //     " An extraction cycle on an unlevel floor does not just feel wrong, it methodically damages bearings, loosens anchor points, and shortens machine life with every spin. We check load-bearing capacity and surface levelness at each installation point and correct any issues before positioning begins, because fixing it afterwards costs far more.",
    //   img: "/assets/images/power-img4.webp",
    // },
    {
      id: "Ventilation Setup",
      title: "Bad Ducting Wastes Energy",
      description:
        "A dryer connected to undersized or poorly routed ducting cannot move heat and moisture out fast enough to dry efficiently. The machine works harder, uses more energy, and still underdelivers. We design the correct exhaust path, verify duct sizing, and confirm airflow before any dryer is signed off.",
      img: "/assets/images/power-img5.webp",
    },
    {
      id: "Utility Mismatch",
      title: "Mismatches Stop Installations",
      description:
        "Steam pressure, gas rating, electrical phase, water temperature. Any one of these out of alignment with the machine specification brings installation to a halt until it is resolved. We audit every utility condition against every machine requirement in advance so nothing is discovered for the first time on installation day.",
      img: "/assets/images/power-img6.webp",
    },
  ];
  return (
    <>
      <section className="tabber-section">
        <div className="container">
          {/* Heading */}
          <div className="row justify-content-center">
            <div className="col-md-12 col-lg-8">
              <div className="heading-text">
                <h4 className="heading">Installation <br /> Challenges We Solve
                </h4>
              </div>
            </div>
          </div>

          <div className="tabber-inner">
            <ul className="nav nav-tabs" role="tablist">
              {tabs.map((tab) => (
                <li className="nav-item" key={tab.id}>
                  <button className={`nav-link ${activeTab === tab.id ? "active" : ""}`} onClick={() => setActiveTab(tab.id)} role="tab"  > {tab.id} </button>
                </li>
              ))}
            </ul>
            <div className="tab-content">
              {tabs.map((tab) => (
                <div key={tab.id} className={`tab-pane ${activeTab === tab.id ? "active" : ""}`} role="tabpanel"  >
                  <div className="tabber-text">
                    <div className="row align-items-center">
                      <div className="col-md-6">
                        <div className="img-wrap">
                          <img className="img-responsive" src={tab.img} loading="lazy" alt="Installation" />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="content">
                          <h3 className="heading">{tab.title}</h3>
                          <p>{tab.description}</p>
                          <div className="tab-btn">
                            <Link className="default-btn" to="/contact"> <span>Lean More</span></Link>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
    </>
  )
}





